import { GroupBase, NoticeProps, components } from 'react-select';
import {
  ComboBoxPrediction,
  IsMulti,
  logErrorToSentry,
  InputErrorMessage,
  ErrorLevel,
} from '~/utilities';
import { useEffect } from 'react';
import { Text } from '@janeapp/burrito-design-system';

export const NoOptionsMessage = ({
  error,
  ...props
}: NoticeProps<ComboBoxPrediction, IsMulti, GroupBase<ComboBoxPrediction>> & {
  error: InputErrorMessage;
}) => {
  useEffect(() => {
    // Only log actual system errors to Sentry, not user-facing warnings
    if (error.type === ErrorLevel.Error) {
      logErrorToSentry({ type: error.type, message: error.message });
    }
  }, [error.message, error.type]);
  return (
    <components.NoOptionsMessage {...props}>
      <Text className="p-3 text-left">{error.userMessage}</Text>
    </components.NoOptionsMessage>
  );
};
